/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createStore, createApi, createEffect, sample } from 'effector';

import { modalApi } from './modals';
import {
  addFaqCategory,
  addFaqQuestion,
  deleteFaqCategory,
  deleteFaqQuestions,
  editFaqCategory,
  editFaqCategoryQuestions,
  editFaqQuestion,
  getFaqCategories,
  getFaqCategoryQuestions,
  getFaqQuestions,
  getStrategiesAdministration,
} from '../api';
import { Question, Category } from '../types/faq';
import { Option } from '../types/option';
import { PageParams } from '../types/pagination';

type TFaq$State = {
  categories: Category[];
  questions: Question[];
  strategies: Option[];
  categoryQuestions: Question[];
};

const initialState: TFaq$State = {
  categories: [],
  questions: [],
  strategies: [],
  categoryQuestions: [],
};

export const Faq$ = createStore<TFaq$State>(initialState);

const { setCategories, setQuestions, setCategoryQuestions, setStrategies } = createApi(Faq$, {
  // @ts-ignore
  setCategories: (state, { result }) => {
    const data = {
      ...state,
      categories: Array.isArray(result) ? result : [],
    };

    return data;
  },
  // @ts-ignore
  setQuestions: (state, { result }) => {
    const data = {
      ...state,
      questions: Array.isArray(result) ? result : [],
    };

    return data;
  },
  setCategoryQuestions: (state, { result }) => {
    if (result && result.questions) {
      return {
        ...state,
        categoryQuestions: result.questions,
      };
    }
    return state;
  },
  setStrategies: (state, { result }) => {
    if (result.result.pageItems) {
      // @ts-ignore
      const strategies = result.result.pageItems.map((item) => ({
        id: item.id,
        name: item.name,
      }));

      return {
        ...state,
        strategies: strategies.concat(strategies).concat(strategies),
      };
    }

    return state;
  },
});

export const faqApi = {
  getCategories: createEffect<'', {}, {}>().use(getFaqCategories),
  addCategory: createEffect<Partial<Category>, {}, {}>().use(addFaqCategory),
  editCategory: createEffect<Category, {}, {}>().use(editFaqCategory),
  removeCategory: createEffect<string, {}, {}>().use(deleteFaqCategory),
  getQuestions: createEffect<'', {}, {}>().use(getFaqQuestions),
  addQuestion: createEffect<Partial<Question>, {}, {}>().use(addFaqQuestion),
  editQuestion: createEffect<Question, {}, {}>().use(editFaqQuestion),
  removeQuestion: createEffect<string, {}, {}>().use(deleteFaqQuestions),
  getCategoryQuestions: createEffect<string, {}, {}>().use(getFaqCategoryQuestions),
  editCategoryQuestions: createEffect<{ categoryId: string; questionIds: string[] }, {}, {}>().use(
    editFaqCategoryQuestions,
  ),
  getStrategies: createEffect<PageParams, {}, {}>().use(getStrategiesAdministration),
};

sample({
  clock: faqApi.getCategories.done,
  target: setCategories,
});

sample({
  clock: faqApi.addCategory.done,
  filter: ({ result }) => Boolean(result),
  fn: (): '' => '',
  target: [modalApi.hide, faqApi.getCategories],
});

sample({
  clock: [faqApi.editCategory.done, faqApi.removeCategory.done],
  fn: (): '' => '',
  target: [modalApi.hide, faqApi.getCategories],
});

sample({
  clock: faqApi.getQuestions.done,
  target: setQuestions,
});

sample({
  clock: faqApi.addQuestion.done,
  filter: ({ result }) => Boolean(result),
  fn: (): '' => '',
  target: [modalApi.hide, faqApi.getQuestions],
});

sample({
  clock: [faqApi.editQuestion.done, faqApi.removeQuestion.done],
  fn: (): '' => '',
  target: [modalApi.hide, faqApi.getQuestions],
});

sample({
  clock: faqApi.getCategoryQuestions.done,
  target: setCategoryQuestions,
});

sample({
  clock: faqApi.editCategoryQuestions.done,
  target: setCategoryQuestions,
});

sample({
  clock: faqApi.getStrategies.done,
  target: setStrategies,
});
